import StockoutEmployeePanel from './stockoutEmployeePanel.container';

export default StockoutEmployeePanel;